import type { TableProps } from '@brokerbay/elements-web';
import { Button, Flex, Icon, Spin, Table, Text } from '@brokerbay/elements-web';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import type { FinalTour } from './types';
import VirtualTabContext from './VirtualTabContext';
import VirtualTourModal from './VirtualTourModal';

const SelectVirtualTour: React.FC = () => {
  const { bookFor, coop, tours, isLoading, selectedTourId, setSelectedTourId } =
    useContext(VirtualTabContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!coop) {
    return null;
  }
  if (isLoading) {
    return <Spin dataCy="loadingIcon" />;
  }

  const isSelf = bookFor === 'self';
  const nameStr = `${isSelf ? 'You have' : `${coop.firstName} ${coop.lastName} has`} no tours`;

  const addDatacy =
    (key: string) =>
    ({ id }: { id: string }) => ({ 'data-cy': `${key}-${id}` } as React.HTMLAttributes<HTMLElement>);
  const columns: TableProps<FinalTour>['columns'] = [
    {
      title: 'Name of Tour',
      dataIndex: 'tourName',
      align: 'center',
      onCell: addDatacy('tour-name'),
    },
    {
      title: '# of Listings',
      dataIndex: 'listingsCount',
      align: 'center',
      onCell: addDatacy('tour-listingsCount'),
    },
    {
      title: 'Date / Time',
      dataIndex: 'startTime',
      align: 'center',
      onCell: addDatacy('tour-date'),
    },
  ];

  return (
    <Flex vertical gap="small" align="center" justify="center">
      {tours && tours.length ? (
        <StyledTable
          columns={columns}
          dataSource={tours}
          rowSelection={{
            selectedRowKeys: [selectedTourId],
            onChange: selectedRowKeys =>
              setSelectedTourId(selectedRowKeys[0].toString()),
            type: 'radio',
          }}
          pagination={false}
          size="middle"
          bordered
          dataCy="vt-table"
        />
      ) : (
        <Text size="large" thickness="bold">
          {nameStr}
        </Text>
      )}
      <Button
        dataCy="addVT-button"
        icon={<Icon icon="plusOutlined" color="white" size={18} />}
        size="middle"
        shape="round"
        type="primary"
        onClick={() => setIsModalOpen(true)}
      >
        Create New Tour
      </Button>
      <VirtualTourModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
    </Flex>
  );
};
const StyledTable = styled(Table<FinalTour>)`
  && {
    width: 100%;
    margin-bottom: 20px;
    text-align: center;
  }
`;

export default SelectVirtualTour;
